import React from "react";

function BackIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g id="Back_Icon" data-name="Back Icon" transform="translate(-324 -164)">
        <circle
          id="Ellipse_2417"
          data-name="Ellipse 2417"
          cx="16"
          cy="16"
          r="16"
          transform="translate(324 164)"
          opacity="0.7"
        />
        <path
          id="Back_Icon-2"
          data-name="Back Icon"
          d="M11.6,13.742l6.3,6.3-1.8,1.8L8,13.742l8.1-8.1,1.8,1.8Z"
          transform="translate(326.047 166.258)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default BackIcon;
